import { render, staticRenderFns } from "./renewalPoins.vue?vue&type=template&id=68b87e92&scoped=true&"
import script from "./renewalPoins.vue?vue&type=script&lang=js&"
export * from "./renewalPoins.vue?vue&type=script&lang=js&"
import style0 from "./renewalPoins.vue?vue&type=style&index=0&id=68b87e92&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b87e92",
  null
  
)

export default component.exports